import { render, staticRenderFns } from "./TabSuppliers.vue?vue&type=template&id=238f65f4&scoped=true&"
import script from "./TabSuppliers.vue?vue&type=script&lang=js&"
export * from "./TabSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./TabSuppliers.vue?vue&type=style&index=0&id=238f65f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238f65f4",
  null
  
)

export default component.exports